import { useEffect, useState } from "react"
import Input from "../../../components/Input"
import Map from "../../../components/Map"
import Popup from "../../../components/Popup"
import Select from "../../../components/Select"
import { authAxios } from "../../../helpers/axios"
import ImageInput from "../../../components/ImageInput"
import MultiSelect from 'react-select';
import CropPopup from "../../../components/CropPopup"
import { COUNTRIES, LIMIT, RETAILER_IMAGE_BASE_URL } from "../../../helpers/constants"
import { ErrorToast } from "../../../helpers/toasters"
import { IoAddCircle, IoRemoveCircle } from "react-icons/io5"

export default function EditTea({onClose,edit=false,onSubmit,updateData,submitting})
{
    const [manageData,setManageData] = useState(!edit ? {rate:'',name:'',warehouseId:'',type:'',contactEmail:'',address:'',status:1,receivedDate:new Date()} : {gardenId:updateData.gardenId,warehouseId:updateData.warehouseSection.warehouseId,type:updateData.type,invoiceNumber:updateData.invoiceNumber,gradeId:updateData.gradeId,cityId:updateData.cityId,warehouseSectionId:updateData.warehouseSectionId})
    const formName = 'manageRawTea';
    const [gardens,setGardens]  = useState([])
    const [warehouses,setWarehouses] = useState([])
    const [selectedWarehouse,setSelectedWarehouse] = useState(null)
    const [count,setCount] = useState(0)
    const [grades,setGrades] = useState([])
    const [cities,setCities] = useState([])


    function addTeaBag(){
        setManageData(data=>({...data,teabags:[...data.teabags,{type:'',numberOfBags:''}]}))
    }
    function removeTeaBag(index){
        setManageData(data=>({...data,teabags:data.bags.filter((item,i)=>i !== index)}))
    }
    async function getGardens(){

        try 
        {
            let query = `&limit=${LIMIT}&offset=${0}`;
            let res = await authAxios.get(`${process.env.REACT_APP_BASE_URL}/garden?populate=true${query}`)
            if(res.data.data) 
            {
                setGardens(res.data.data)
                setCount(res.data.count)
            }
        } catch (error) {
            console.log(error)
            ErrorToast('Error getting gardens')
        }
    }
    
    async function getWarehouses(){

        try 
        {
            let query = `&limit=${LIMIT}&offset=${0}`;
            let res = await authAxios.get(`${process.env.REACT_APP_BASE_URL}/warehouse?populate=true${query}`)
            setWarehouses(res.data)
        } catch (error) {
            console.log(error)
            ErrorToast('Error getting warehouses')
        }
    }
    async function getCities(){

        try 
        {
            let res = await authAxios.get(`${process.env.REACT_APP_BASE_URL}/city`)
            setCities(res.data)
        } catch (error) {
            console.log(error)
            ErrorToast('Error getting cities')
        }
    }
    async function getGrades(){

        try 
        {
            let res = await authAxios.get(`${process.env.REACT_APP_BASE_URL}/grade`)
            setGrades(res.data)
        } catch (error) {
            console.log(error)
            ErrorToast('Error getting grades')
        }
    }
    
    async function getWarehouseInfo(){

        console.log(manageData)
        try 
        {
            let query = `&limit=${LIMIT}&offset=${0}`;
            let res = await authAxios.get(`${process.env.REACT_APP_BASE_URL}/warehouse/${manageData.warehouseId}?populate=true${query}`)
            setSelectedWarehouse(res.data)
            // if(res.data.data) 
            // {
            //     setCount(res.data.count)
            // }
        } catch (error) {
            console.log(error)
            ErrorToast('Error getting warehouse Info')
        }
    }

    useEffect(()=>
        {
            getGardens()
            getGrades()
            getCities()
            getWarehouses()
        },[])
   
        useEffect(()=>
        {
            getWarehouseInfo()
        },[manageData.warehouseId])


        const setItem = (type,index,value)=>
        {
            setManageData((prev)=>
            {
            let newData = {...prev}
    
            // let newBomData = newData.products[index]
            if(type === 'type') newData.teabags[index].type = value
            if(type === 'numberOfBags') newData.teabags[index].numberOfBags = value
    
            return newData;
            })
    
        }



    return <><Popup size="sm" submitting={submitting} title={edit ? 'Update Raw Tea Entry' : 'Create Raw Tea Entry'} submitTitle={edit ? 'Update' : 'Create'} onClose={onClose} formName={formName}>
        <form onSubmit={(e)=>onSubmit(e,{...manageData})} id={formName} className='w-full'>
                <div className="block grid-cols-2 gap-x-3 gap-y-0 w-full">
            <div className="grid grid-cols-4 gap-x-3 gap-y-0 w-full">
            <div className="col-span-2">
                <label>Select Garden</label>
                <Select placeholder={'Select Garden'} options={gardens} customLabel={'name'} customValue={'id'}  value={manageData.gardenId} setValue={(value)=>setManageData(data=>({...data,gardenId:value}))}/>
            </div>
            <div className="col-span-2">
                <label>Tea Type</label>
                <Select placeholder={'Select Tea Type'} options={[{name:'Leaf Tea',value:'leaf'},{name:'Dust Tea',value:'dust'},{name:'Green Tea',value:'green'}]}  value={manageData.type} setValue={(value)=>setManageData(data=>({...data,type:value}))}/>
            </div>
            <div className="col-span-2">
                <label>Place of Origin</label>
                {/* <Input type='text' placeholder={'Enter Place of Origin'} value={manageData.origin} setValue={(value)=>setManageData(data=>({...data,origin:value}))}/> */}
                <Select placeholder={'Select Place of Origin'} options={cities}  customValue={'id'} value={manageData.cityId} setValue={(value)=>setManageData(data=>({...data,cityId:value}))}/>
            </div>
            <div className="col-span-2">
                <label>Grade</label>
                <Select placeholder={'Select Grade'} options={grades} customValue={'id'}  value={manageData.gradeId} setValue={(value)=>setManageData(data=>({...data,gradeId:value}))}/>
            </div>
            <div className="col-span-2">
                <label>Invoice Number</label>
                <Input type='text' placeholder={'Enter Invoice Number'} value={manageData.invoiceNumber} setValue={(value)=>setManageData(data=>({...data,invoiceNumber:value}))}/>
            </div>
            {/* <div className="col-span-2">
                <label>Rate (Per Kg)</label>
                <Input type='number' placeholder={'Enter Rate (Per Kg)'} value={manageData.rate} setValue={(value)=>setManageData(data=>({...data,rate:value}))}/>
            </div> */}

            <div className="col-span-2">
                <label>Select Warehouse</label>
                <Select placeholder={'Select Warehouse'} options={warehouses} customLabel={'name'} customValue={'id'}  value={manageData.warehouseId} setValue={(value)=>setManageData(data=>({...data,warehouseId:value}))}/>
            </div>
            <div className="col-span-2">
                <label>Select Section</label>
                <Select placeholder={'Select Section'} options={selectedWarehouse?.sections ? selectedWarehouse.sections : []} customLabel={'name'} customValue={'id'}  value={manageData.warehouseSectionId} setValue={(value)=>setManageData(data=>({...data,warehouseSectionId:value}))}/>
            </div>
            </div>
            </div>
        </form>
    </Popup>
    </>
}
